import axios from "axios";

const url = process.env.REACT_APP_ENVIRONMENT === 'dev' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD
const header = process.env.REACT_APP_ENVIRONMENT === 'dev' ? process.env.REACT_APP_API_KEY_DEV : process.env.REACT_APP_API_KEY_PROD
/// post전송 
export const postAsync = async (apiUrl, postData, token) => {

  try {
    const authResponse = await axios.post(`${url}${apiUrl}`, postData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : `Bearer ${header}`
      }
    });
    return authResponse.data;
  } catch (error) {
    const errorStatus = error.response.status;
    const errorMessage = error.response.data.message;
    return {
      errorStatus, errorMessage, data: null
    }
  }
};



// 로그인
export const userLogin = async (id, password) => {
  // return await postAsync('/v2/auth/login/admin', {
  //   username: id,
  //   password: password,
  //   role: "admin"
  // }, {});

  const data = {
    username: id,
    password: password,
    role: "admin"
  }
  try {
    const authResponse = await axios.post(`${url}/v2/auth/login/admin`, data, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": ``
      }
    });
    return authResponse.data;
  } catch (error) {
    const errorStatus = error.response.status;
    const errorMessage = error.response.data.message;
    return {
      errorStatus, errorMessage, data: null
    }
  }
};